import type { UniDriver } from '@wix/unidriver-core';

export const wixDesignSystemProviderDriverFactory = (base: UniDriver) => {
  return {
    exists: async () => base.exists(),
    element: async () => base.getNative(),
    // TODO: remove with major release
    /**
     * @deprecated This method is deprecated and will be removed in the next major release. It's always true now, since old branding doesn't exist anymore.
     */
    isNewColorsBrandingEnabled: async () => true,
  };
};

export type WixDesignSystemProviderUniDriver = ReturnType<
  typeof wixDesignSystemProviderDriverFactory
>;
